import { render, staticRenderFns } from "./Settings-calendar.vue?vue&type=template&id=7fbf6277&scoped=true&"
import script from "./Settings-calendar.vue?vue&type=script&lang=js&"
export * from "./Settings-calendar.vue?vue&type=script&lang=js&"
import style0 from "./Settings-calendar.vue?vue&type=style&index=0&id=7fbf6277&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf6277",
  null
  
)

export default component.exports